import { useAzureChatStore } from '@/modules/chat/azureChatStore'
import store from '@/store'

export default {
  async getChatThreadClient(chatThreadId) {
    const azureChatStore = useAzureChatStore()
    const chatClient = await azureChatStore.getChatClient()
    return chatClient.getChatThreadClient(chatThreadId)
  },

  async getChatThreads() {
    const azureChatStore = useAzureChatStore()
    const chatClient = await azureChatStore.getChatClient()
    const chatThreadIterator = chatClient.listChatThreads()

    const chatThreads = []
    for await (const chatThread of chatThreadIterator) {
      chatThreads.push(chatThread)
    }

    return chatThreads
  },
  async sendMessage(chatThreadId, message, metadata = {}) {
    const chatThreadClient = await this.getChatThreadClient(chatThreadId)

    const sendMessageOptions = {
      senderDisplayName: store.getters['auth/userId'].toString(),
      type: 'text',
      metadata,
    }
    return chatThreadClient.sendMessage(
      { content: message },
      sendMessageOptions,
    )
  },
  async updateMessage(chatThreadId, messageId, options) {
    const chatThreadClient = await this.getChatThreadClient(chatThreadId)

    return chatThreadClient.updateMessage(
      messageId,
      options,
    )
  },
  async deleteMessage(chatThreadId, messageId) {
    const chatThreadClient = await this.getChatThreadClient(chatThreadId)

    return chatThreadClient.deleteMessage(messageId.toString())
  },
  async getMessage(chatThreadId, messageId) {
    const chatThreadClient = await this.getChatThreadClient(chatThreadId)

    return chatThreadClient.getMessage(messageId.toString())
  },
  async getReadReceipts(chatThreadId) {
    const chatThreadClient = await this.getChatThreadClient(chatThreadId)
    const chatThreadReadReceiptsIterator = chatThreadClient.listReadReceipts()

    const readReceipts = []
    for await (const readReceipt of chatThreadReadReceiptsIterator) {
      readReceipts.push({
        chatMessageId: readReceipt.chatMessageId,
        readOn: readReceipt.readOn,
        sender: readReceipt.sender,
      })
    }
    return readReceipts
  },
  async setReadingEvent(chatThreadId, chatMessageId) {
    const chatThreadClient = await this.getChatThreadClient(chatThreadId)
    return chatThreadClient.sendReadReceipt({ chatMessageId })
  },
  async setTypingEvent(chatThreadId) {
    const chatThreadClient = await this.getChatThreadClient(chatThreadId)
    return chatThreadClient.sendTypingNotification({ senderDisplayName: store.getters['auth/userId'].toString() })
  },

}
